import { render, staticRenderFns } from "./Inproceeding.vue?vue&type=template&id=00d14096"
import script from "./Inproceeding.vue?vue&type=script&lang=js"
export * from "./Inproceeding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports